<template>
    <h5 class="mb-4">Alta de Rol</h5>
    <Form role="form"
          class="text-start"
          @submit="handleAltaRol"
          >
        <soft-field
            id="nombre"
            v-model="rol.nombre"
            type="text"
            label="Nombre"
            placeholder="Indique nombre del rol"
            name="nombre"
            class="mb-2"
        />
        <div style="height:10px;"></div>
        <label for="none">Permisos</label>
        <div class="row">
            <div class="col-sm-6" v-for="permiso in permisos2" :key="permiso.id">
            <soft-switch :id="'permiso' + permiso.id" :name="'permiso' + permiso.id" @change="cambiarDinamico('permiso' + permiso.id)" style="display:inline-block;"/>
            <label :for="'permiso' + permiso.id">{{permiso.descripcion}}</label>
            </div>
        </div>

        <div class="text-center mt-5">
            <soft-button
                class="my-2 mb-2 text-sm"
                color="analiza-azul"
                full-width
                :is-disabled="loading ? true : false"
                >
                <span
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                ></span>
                <span v-else>Confirmar</span>
            </soft-button>
        </div>
    </Form>
  </template>
  
  <script>
  import SoftField from "@/components/SoftField.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import SoftSwitch from "@/components/SoftSwitch.vue";
  import showSwal from "/src/mixins/showSwal.js";
  import { Form } from "vee-validate";
  import * as yup from "yup";

  export default {
    name: "AltaRolForm",
    components: {
        SoftField,
        SoftButton,
        SoftSwitch,
        Form,
    },
    data() {
        return {
            loading: false,
            rol: {
                nombre: "",
            },
            permisos: {},
            permisos2: [],
            schema: yup.object().shape({
                nombre: yup.string().required("El nombre es necesario!"),
            }),
        };
    },
    emits: ['cerrar-modal'],
    methods: {
        async handleAltaRol() {
            // Aquí puedes realizar acciones cuando se envía el formulario
            this.loading = true;
            try {             
                this.loading = false;
                this.permisos['nombre'] = this.rol.nombre; 
                const resp = await this.$store.dispatch("auth/guardaRol", this.permisos);
                if (resp.res=='OK') {
                    showSwal.methods.showSwal({
                        type: "success",
                        message: "Se ha registrado el nuevo rol",
                        width: 600,
                    });
                    this.$emit('cerrar-modal');
                }
                else {
                    showSwal.methods.showSwal({
                        type: "error",
                        message: resp.mensaje,
                        width: 500
                    });               
                }
            } catch (error) {
                this.loading = false;
                showSwal.methods.showSwal({
                    type: "error",
                    message: "Se ha producido un error",
                    width: 500,
                });
            }
        },
        cambiarDinamico(id) {
            this.permisos[id] = this.permisos[id] == 0 ? 1 : 0;
        }
    },
    async mounted() {
        const permisos2 = await this.$store.dispatch("auth/permisos");

        const permisos = {};
        for (let i = 0; i < permisos2.length; i++) {
            permisos['permiso' + permisos2[i].id] = 0;
        }

        this.permisos2 = permisos2;
        this.permisos = permisos;
    }

  };
  </script>
  
  <style scoped>
  /* Estilos específicos del componente MyForm */
  </style>